<template>
  <div v-if="showDialog" class="dialog-overlay" @click.self="close">
    <div class="dialog-content">
      <div class="dialog-body">
        <img class="img" src="https://semeq.com/wp-content/themes/Semeq/assets/images/logo-semeq.svg"
          alt="Logo da Semeq">
        <!-- Ícone de Erro -->
        <div class="error-icon">
          &#9888; <!-- Símbolo de aviso -->
        </div>
        <h1 class="h1">{{ $t("383") }}</h1>

        <p class="p"> {{ $t("380") }} </p>

        <div class="contact-info">
          <p class="p"> {{ $t("381") }} </p>
          <p class="p">
            <i class="fa fa-envelope"></i><a href="mailto:servicedesk@semeq.com">servicedesk@semeq.com</a><br>
            <i class="fa fa-phone"></i>+5519997107611
          </p>
        </div>
      </div>
      <div class="dialog-footer">
        <button @click="close">{{ $t("382") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Título do Diálogo'
    }
  },
  methods: {
    close() {
      this.showDialog = false
      this.$emit('update:visible', false);
      localStorage.setItem("DescontinuationWarning", "0")
    }
  },
  data() {
    return {
      showDialog: `${localStorage.getItem("DescontinuationWarning")}` === "0" ? false : true
    };
  }
};
</script>

<style scoped>
.dialog-overlay {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: 100%;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: start;
  justify-content: center;
  z-index: 99999999999999;
}

.dialog-content {
  max-width: 75vw;
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-top: 10%;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
}

.dialog-title {
  margin-top: 0;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}

.dialog-body {
  font-family: Arial, sans-serif;
  font-size: 1rem;
  text-align: center;
  padding: 40px;
}

/*******************************************************************************************************************/
.h1 {
  color: #e74c3c;
  font-size: 2.5em;
}

.p {
  font-size: 1.6em;
}

.img {
  width: 200px;
  margin-bottom: 30px;
}

.error-icon {
  font-size: 80px;
  color: #e74c3c;
}

.endpoint-link {
  color: #3498db;
  text-decoration: none;
  font-weight: bold;
}

.contact-info {
  font-size: 1.1em;
  margin-top: 30px;
}

.contact-info a {
  color: #3498db;
  text-decoration: none;
  font-weight: bold;
}

.contact-info i {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/DescontinuationWarning.vue